var exports = {
  "YW": "Page__W6j-xz",
  "G6": "PricingOptionsSection__9678-d",
  "aE": "OverlapSectionEnd__aDNNM4",
  "ap": "ContainOverlap__HkXsW_",
  "lY": "PricingOptions__nkfosV",
  "Di": "ComparisonTableSection__rgpkkW",
};

module.exports = exports;
